import React from "react";
import { Underline } from "./Underline";

export const Program = () => {
  return (
    <div className="container ">
      <div className="section-header mb-60 text-center ">
        <h2
          className="wow fadeInUp "
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          Our Programmes
        </h2>
        <Underline />

        <p className="fs-20 fw-700">
          Joining Hands focuses on making less privileged youth financially
          independent by providing them a platform to harness and develop their
          skills and potential.
        </p>
      </div>
      <div className="row g-4">
        <div
          className="col-xl-4 col-md-6 wow fadeInUp"
          data-wow-delay="00ms"
          data-wow-duration="1500ms"
        >
          <div className="service__item first">
            <div className="service__icon  ">
              <img
                src="images/icon/enhance.svg"
                style={{ width: "50px", height: "50px" }}
                alt="icon"
              />
             <h3 className="text-white">Skill Development</h3>
            </div>
            <div className="service__content">
             
              <p className="text-white">
                Our program focuses on building essential life and job skills
                through practical training in communication, digital literacy,
                and vocational fields. We aim to make every learner confident,
                capable, and ready for the workforce.
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-xl-4 col-md-6 wow fadeInUp"
          data-wow-delay="200ms"
          data-wow-duration="1500ms"
        >
          <div className="service__item active">
            <div className="service__icon">
              <img
                src="images/icon/education.svg"
                className=""
                style={{ width: "50px", height: "50px" }}
                alt="icon"
              />
              <h3 className="text-white">Scholarship Program</h3>
            </div>
            <div className="service__content">
              
              <p className="text-white">
                Through our Scholarship Initiative, deserving students from
                underprivileged backgrounds receive financial support to pursue
                education and skill training - ensuring that no dream is left
                behind.
              </p>
            </div>
          </div>
        </div>
        <div
          className="col-xl-4 col-md-6 wow fadeInUp"
          data-wow-delay="400ms"
          data-wow-duration="1500ms"
        >
          <div className="service__item">
            <div className="service__icon">
              <img
                src="images/icon/others.svg"
                style={{ width: "50px", height: "50px" }}
                alt="icon"
              />
              <h3 className="text-white">Community Engagement & Awareness</h3>
            </div>
            <div className="service__content">
              
              <p className="text-white">
                {" "}
                Regular workshops, school outreach programs, and youth events
                focused on leadership, confidence-building, and career awareness
                .
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Program;
